  /* ── Commerce core: tier picker, warranty opt-in, AJAX add -> /checkout.
     Mirrors the client's own pdp3 mechanic (add to cart then straight to
     checkout, never the cart page), so events fire through their native
     web-pixels pipeline. */
  (function () {
    var buy = document.querySelector('[data-mehdi-buy]');
    if (!buy) return;
    var pricesEl = buy.querySelector('[data-mehdi-buy-prices]');
    var prices = pricesEl ? JSON.parse(pricesEl.textContent) : null;
    var tierInputs = buy.querySelectorAll('input[name="mehdi-tier"]');
    var warranty = buy.querySelector('[data-mehdi-warranty]');
    var totalEls = document.querySelectorAll('[data-mehdi-total], [data-mehdi-sticky-total]');
    var totalWasEls = document.querySelectorAll('[data-mehdi-total-was], [data-mehdi-sticky-was]');

    function tier() {
      var checked = buy.querySelector('input[name="mehdi-tier"]:checked');
      return checked ? checked.value : '1';
    }

    function refresh() {
      if (!prices) return;
      var key = (tier() === '2' ? 't2' : 't1') + (warranty && warranty.checked ? 'w' : '');
      var pair = prices[key] || prices.t1;
      /* No compare-at on the product (EU unlock): never strike the same price. */
      var showWas = prices.hasCompare !== false && pair[0] !== pair[1];
      totalWasEls.forEach(function (el) { el.textContent = showWas ? pair[0] : ''; el.hidden = !showWas; });
      totalEls.forEach(function (el) { el.textContent = pair[1]; });
      buy.querySelectorAll('.mehdi-pdp__buy-tier').forEach(function (card) {
        var input = card.querySelector('input[name="mehdi-tier"]');
        card.classList.toggle('is-active', !!(input && input.checked));
      });
    }

    tierInputs.forEach(function (input) { input.addEventListener('change', refresh); });
    var warrantyToggle = buy.querySelector('[data-mehdi-warranty-toggle]');
    if (warrantyToggle && warranty) {
      warrantyToggle.addEventListener('click', function () {
        warranty.checked = !warranty.checked;
        warrantyToggle.classList.toggle('is-on', warranty.checked);
        warrantyToggle.setAttribute('aria-pressed', String(warranty.checked));
        refresh();
      });
    } else if (warranty) {
      warranty.addEventListener('change', refresh);
    }
    refresh();

    function checkout(button) {
      var items = [{ id: parseInt(buy.dataset.baseId, 10), quantity: 1 }];
      if (tier() === '2' && buy.dataset.secondId) items.push({ id: parseInt(buy.dataset.secondId, 10), quantity: 1 });
      if (warranty && warranty.checked && buy.dataset.warrantyId) items.push({ id: parseInt(buy.dataset.warrantyId, 10), quantity: 1 });
      button.disabled = true;
      /* Clear first so a back-button re-click never stacks the cart (get parity),
         then verify: an open-checkout restore can re-inject stale lines. */
      var desired = {};
      items.forEach(function (it) { desired[it.id] = (desired[it.id] || 0) + it.quantity; });
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' }).catch(function () {}).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        });
      }).then(function (res) {
        if (!res.ok) throw new Error('cart');
        return fetch('/cart.js').then(function (cr) { return cr.json(); }).then(function (cart) {
          var updates = {}, dirty = false;
          (cart.items || []).forEach(function (line) {
            var want = desired[line.variant_id] || 0;
            if (line.quantity !== want) { updates[line.variant_id] = want; dirty = true; }
          });
          if (!dirty) return;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).catch(function () {});
        }).catch(function () {});
      }).then(function () {
        if (window.HumeCart && window.HumeCart.active) { window.HumeCart.open(); }
        else { window.location.href = '/checkout'; }
      }).catch(function () {
        /* Fallback: a cart permalink also lands on checkout. */
        window.location.href = '/cart/' + items.map(function (it) { return it.id + ':' + it.quantity; }).join(',');
      });
    }

    document.querySelectorAll('[data-mehdi-checkout]').forEach(function (btn) {
      btn.addEventListener('click', function () { checkout(btn); });
    });

    /* Sticky bar visibility: shown once the buy box has scrolled out of view. */
    var sticky = document.querySelector('.mehdi-pdp__sticky');
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(buy);
    }
  })();

  /* Rolling countdown to local midnight — same face as the engine's
     limited-time cards, never a frozen number. */
  document.querySelectorAll('[data-mehdi-countdown]').forEach(function (el) {
    var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    if (!h) return;
    function tick() {
      var now = new Date();
      var end = new Date(now); end.setHours(24, 0, 0, 0);
      var d = Math.max(0, end - now) / 1000;
      h.textContent = String(Math.floor(d / 3600)).padStart(2, '0');
      m.textContent = String(Math.floor(d % 3600 / 60)).padStart(2, '0');
      s.textContent = String(Math.floor(d % 60)).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

/* hero.js — behavior for hero-band.liquid + hero-pod.liquid. Bare statements
   (paste into the page's <script>, matches the convention in
   mehdi-listicle.liquid / frame-core.js). Vanilla JS only, no dependencies.
   Every animated bit is guarded by prefers-reduced-motion where relevant. */

/* Gallery: thumbnail click (or jump-bar pill) swaps the active main slide.
   Scoped per gallery root so hero-band.liquid + hero-pod.liquid can both be
   on the page (e.g. a preview harness) without one gallery driving the other. */
document.querySelectorAll('[data-mehdi-hero-gallery]').forEach(function (root) {
  var slides = root.querySelectorAll('.mehdi-pdp__hero-slide');
  var thumbs = root.querySelectorAll('.mehdi-pdp__hero-thumb');
  var strip = root.querySelector('.mehdi-pdp__hero-thumbs');
  var frame = root.querySelector('.mehdi-pdp__hero-frame');
  var count = slides.length;

  function current() {
    var a = root.querySelector('.mehdi-pdp__hero-slide.is-active');
    return a ? parseInt(a.dataset.slide, 10) || 0 : 0;
  }

  /* Keep the active thumbnail in view: the strip scrolls so the thumb sits
     centred (15 Pod / 14 Band thumbs never fit the strip at any width). */
  function followThumb(index) {
    if (!strip) return;
    var t = strip.querySelector('.mehdi-pdp__hero-thumb[data-slide="' + index + '"]');
    if (!t) return;
    var left = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { strip.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' }); }
    catch (e) { strip.scrollLeft = Math.max(0, left); }
  }

  function goTo(index) {
    index = ((parseInt(index, 10) || 0) % count + count) % count;
    slides.forEach(function (s) {
      var match = s.dataset.slide === String(index);
      s.classList.toggle('is-active', match);
      /* is-shown gates the CSS entrance animations on the restored data-panel
         slides (BP / sleep / recomp / visceral / segmental / pod-dexa rows):
         removed from every slide but the active one, then re-added here, so
         the animation (re)plays every time the switcher brings that slide
         into view — mirroring the React components' mount-triggered
         keyframes, which remount (and so replay) each time React shows them. */
      s.classList.toggle('is-shown', match);
      var v = s.querySelector('video');
      if (v && !match && !v.paused) v.pause();
    });
    thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.slide === String(index)); });
    var active = root.querySelector('.mehdi-pdp__hero-slide.is-active video');
    if (active && active.paused) { active.play().catch(function () {}); }
    followThumb(index);
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { goTo(t.dataset.slide); });
  });

  root.querySelectorAll('[data-mehdi-hero-jump]').forEach(function (btn) {
    btn.addEventListener('click', function () { goTo(btn.dataset.mehdiHeroJump); });
  });

  /* Prev / next arrows (desktop) */
  root.querySelectorAll('[data-mehdi-hero-prev]').forEach(function (btn) {
    btn.addEventListener('click', function () { goTo(current() - 1); });
  });
  root.querySelectorAll('[data-mehdi-hero-next]').forEach(function (btn) {
    btn.addEventListener('click', function () { goTo(current() + 1); });
  });

  /* Swipe on touch, drag on desktop. Pointer events with touch-action:pan-y on
     the frame (CSS) so a vertical scroll still belongs to the page; a mostly
     horizontal move of 40px+ turns the slide. */
  if (frame && 'PointerEvent' in window) {
    var startX = 0, startY = 0, tracking = false, pointerId = null;
    frame.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest && e.target.closest('button, a, video[controls]')) return;
      startX = e.clientX; startY = e.clientY; tracking = true; pointerId = e.pointerId;
    });
    frame.addEventListener('pointermove', function (e) {
      if (!tracking || e.pointerId !== pointerId || e.pointerType !== 'mouse') return;
      /* Mouse drag: stop the browser from starting an image drag. */
      if (Math.abs(e.clientX - startX) > 6) e.preventDefault();
    });
    var end = function (e) {
      if (!tracking || e.pointerId !== pointerId) return;
      tracking = false;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      goTo(current() + (dx < 0 ? 1 : -1));
    };
    frame.addEventListener('pointerup', end);
    /* An inner scroll container (the Band "It never stops working" card has
       overflow-y:auto) makes the browser claim the pan: pointercancel fires
       and pointerup never comes. Keep the gesture alive on the touch events,
       which still end normally, and decide on touchend instead. */
    var cancelled = false;
    frame.addEventListener('pointercancel', function () { if (tracking) cancelled = true; tracking = false; });
    frame.addEventListener('touchstart', function (e) {
      var t = e.touches && e.touches[0];
      if (!t) return;
      cancelled = false;
      if (!tracking) { startX = t.clientX; startY = t.clientY; }
    }, { passive: true });
    frame.addEventListener('touchend', function (e) {
      if (!cancelled) return;
      cancelled = false;
      var t = e.changedTouches && e.changedTouches[0];
      if (!t) return;
      var dx = t.clientX - startX, dy = t.clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      goTo(current() + (dx < 0 ? 1 : -1));
    }, { passive: true });
    frame.addEventListener('dragstart', function (e) { e.preventDefault(); });
    /* Keyboard: arrows move the gallery once it has focus (thumbs are buttons). */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
    });
  }
});

/* Warranty opt-in row: no cart logic here (that lives in MEHDI_BUY_SLOT's own
   commerce script) — this only keeps the border/background in sync with the
   checkbox for engines where :has() support is patchy. */
document.querySelectorAll('.mehdi-pdp__hero-warranty').forEach(function (row) {
  var box = row.querySelector('input[type="checkbox"]');
  if (!box) return;
  var sync = function () { row.classList.toggle('is-checked', box.checked); };
  box.addEventListener('change', sync);
  sync();
});

/* Mini review gallery: prev/next + dots + auto-advance every 5s, paused on
   hover/focus (MiniReviewGallery.tsx). */
document.querySelectorAll('[data-mehdi-hero-reviews]').forEach(function (root) {
  var slide = root.querySelector('[data-mehdi-rev-slide]');
  var quote = slide ? slide.querySelector('[data-mehdi-rev-quote]') : null;
  var author = slide ? slide.querySelector('[data-mehdi-rev-author]') : null;
  var location = slide ? slide.querySelector('[data-mehdi-rev-location]') : null;
  var dots = root.querySelectorAll('[data-mehdi-rev-dot]');
  var reviews = [];
  try { reviews = JSON.parse(root.querySelector('[data-mehdi-rev-data]').textContent); } catch (e) { reviews = []; }
  if (!reviews.length || !slide) return;

  var index = 0;
  var paused = false;
  var timer = null;

  /* Every review renders 5/5 (star-rating/MiniReviewGallery default —
     the config carries no per-review rating field), so the star row is
     static markup and never needs to change between slides. */
  function render() {
    var r = reviews[index];
    if (quote) quote.textContent = '“' + r.text + '”';
    if (author) author.textContent = r.author;
    if (location) location.textContent = r.location ? ' · ' + r.location : '';
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
  }

  function go(delta) {
    index = (index + delta + reviews.length) % reviews.length;
    render();
    reset();
  }

  function reset() {
    if (timer) clearTimeout(timer);
    if (paused || reviews.length <= 1) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;
    timer = setTimeout(function () { index = (index + 1) % reviews.length; render(); reset(); }, 5000);
  }

  var prevBtn = root.querySelector('[data-mehdi-rev-prev]');
  var nextBtn = root.querySelector('[data-mehdi-rev-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });
  dots.forEach(function (d, i) {
    d.addEventListener('click', function () { index = i; render(); reset(); });
  });

  root.addEventListener('mouseenter', function () { paused = true; });
  root.addEventListener('mouseleave', function () { paused = false; reset(); });
  root.addEventListener('focusin', function () { paused = true; });
  root.addEventListener('focusout', function () { paused = false; reset(); });

  render();
  reset();
});

/* Video lightbox (HeroGallery.tsx's showActionVideo portal, ported to a native
   <dialog>): the "See it in action" jump pill opens the modal (data-mehdi-
   video-open="#id" points at the matching <dialog data-mehdi-video-lightbox>),
   which plays its own action-cut video — separate from the inline gallery
   video slide. showModal()'s native top-layer promotion is exactly what the
   source's createPortal-to-<body> comment was working around, so no manual
   z-index/portal juggling is needed here. Escape-to-close and the ::backdrop
   are both native <dialog> behavior; only the backdrop-click-to-close and the
   pause-on-close cleanup need JS. */
document.querySelectorAll('[data-mehdi-video-lightbox]').forEach(function (dlg) {
  var video = dlg.querySelector('video');
  var closeBtn = dlg.querySelector('[data-mehdi-video-close]');

  function close() {
    if (dlg.open) dlg.close();
  }

  if (closeBtn) closeBtn.addEventListener('click', close);

  /* Click on the dialog element itself (not a descendant) means the click
     landed on the ::backdrop — <dialog>'s box only wraps its content. */
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg) close();
  });

  /* Fires on Escape (native) and on our own close() calls above. */
  dlg.addEventListener('close', function () {
    if (video) { video.pause(); video.currentTime = 0; }
  });
});

document.querySelectorAll('[data-mehdi-video-open]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var dlg = document.querySelector(btn.getAttribute('data-mehdi-video-open'));
    if (!dlg) return;
    dlg.showModal();
    var video = dlg.querySelector('video');
    if (video) {
      video.currentTime = 0;
      video.play().catch(function () {});
    }
  });
});

/* Scroll lock while any of our <dialog>s is open (video lightbox, metric modal,
   HSA/FSA modal). A native <dialog> does not stop the page behind it from
   scrolling; on iOS overflow:hidden alone is not enough either, so the body is
   pinned at the current offset and released on close. One observer per dialog
   watching the `open` attribute covers every open/close path (showModal,
   Escape, backdrop click, close button). */
(function () {
  'use strict';
  var dialogs = document.querySelectorAll('.mehdi-pdp dialog');
  if (!dialogs.length || !('MutationObserver' in window)) return;
  var lockedY = null;
  function anyOpen() {
    for (var i = 0; i < dialogs.length; i++) if (dialogs[i].open) return true;
    return false;
  }
  function lock() {
    if (lockedY !== null) return;
    lockedY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.classList.add('mehdi-pdp-locked');
    document.body.style.position = 'fixed';
    document.body.style.top = -lockedY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
  }
  function unlock() {
    if (lockedY === null) return;
    var y = lockedY; lockedY = null;
    document.documentElement.classList.remove('mehdi-pdp-locked');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.paddingRight = '';
    /* instant: the page's own scroll-behavior:smooth would animate the restore */
    try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
  }
  function sync() { if (anyOpen()) lock(); else unlock(); }
  dialogs.forEach(function (d) {
    new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['open'] });
    d.addEventListener('close', sync);
  });
})();

/* Offer-slide countdown: rolling countdown to local midnight, same face as the
   integrator's other limited-time cards (frame-core.js / mehdi-listicle.liquid
   use the identical tick()). Both may load on the same page — re-ticking the
   same element from two copies of this loop is harmless (same math, same
   output), so no guard is needed beyond the querySelectorAll scope. */

/* mid.js -- behaviour unique to the Hume Band 2.0 mid-zone PDP fragment
 * (mid-band.liquid). Ported from client/src/components/HumeBelowHero.tsx's
 * mount effect, ES5-ish vanilla JS.
 *
 * Everything else the source component did is either already covered by
 * low.js (reveal-on-scroll for .mehdi-pdp__reveal/.mehdi-pdp__stagger,
 * count-up on [data-count], the revstrip rotation) or was dropped because
 * it targeted markup that no longer exists after this port:
 *   - ".gtile[data-replay]" replay-on-hover, "[data-hoverpts]" chart/ring/
 *     spark tooltips, "[data-bpw]" weekly-bucket tooltip, "[data-revrotate]"
 *     mini-review marquee, "[data-revcarousel]" contextual carousel -- all
 *     confirmed dead/orphaned in the React source itself (no element in the
 *     rendered markup carries the attribute each one queries for)
 *   - CTA click routing -- the remind/lifespan CTAs now use a plain
 *     `href="#band-offer"` anchor (global smooth-scroll is already set by
 *     frame-core.css's `html:has(.mehdi-pdp){scroll-behavior:smooth}`), the
 *     same convention as low-pod.liquid's remind CTAs
 *
 * Restored in this pass (were dropped in an earlier port, per client
 * rejection of "simplified" behaviour -- see mid.notes.md for the source
 * line references each of these is ported from):
 *   - the §7 wine timeline's mobile scroll-snap dot nav: active-dot sync to
 *     scroll position (source: "§7 mobile scroll-snap timeline" effect)
 *   - scroll parallax on [data-parallax] elements: the §6 Pace-of-Aging/
 *     Health-Report app-card duo, the §6 floating review card, and the §7
 *     wine section's Metabolic Momentum card (source: "Lightweight parallax
 *     on flagged elements" effect)
 *   - the shared #metric-modal <dialog>: opened by the §9 spec-grid buttons
 *     and, on touch devices only, the HSA/FSA "i" button (source: "§9
 *     spec-card modal" effect + the HSA/FSA canHover branch)
 *
 * Kept here because no other file's JS covers it:
 *   - section 8's "Trend Alert" toast: springs in once, ~2.5s after the BP
 *     chart card enters the viewport. Reduced motion: appears immediately,
 *     no animation. Wording is trend/pattern language only, never a
 *     diagnosis -- do not change without compliance sign-off.
 */
(function () {
  "use strict";

  document.querySelectorAll(".mehdi-pdp").forEach(function (root) {
    if (root.__mehdiPdpMidBandInit) return;
    root.__mehdiPdpMidBandInit = true;

    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* ============================================================
       Section 8 "Trend Alert" toast
       ============================================================ */
    (function () {
      var bpToast = root.querySelector("[data-bptoast]");
      if (!bpToast) return;

      var toastAnchor = root.querySelector("#blood-pressure .mehdi-pdp__card") || bpToast;
      var toastFired = false;

      function fireToast() {
        if (toastFired) return;
        toastFired = true;
        tIo.disconnect();
        window.removeEventListener("scroll", onToastScroll);
        if (reduceMotion) {
          bpToast.classList.add("mehdi-pdp__no-anim", "mehdi-pdp__on");
        } else {
          setTimeout(function () {
            bpToast.classList.add("mehdi-pdp__on");
          }, 2500);
        }
      }

      var tIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) fireToast();
          });
        },
        { threshold: 0.3 }
      );
      tIo.observe(toastAnchor);

      /* Scroll fallback, same philosophy as low.js's own reveal fallback: fires
         in contexts where IntersectionObserver delivery is suppressed or
         throttled (background tabs, some webviews). */
      function onToastScroll() {
        if (toastFired) return;
        var rect = toastAnchor.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (rect.top < vh * 0.8 && rect.bottom > vh * 0.1) fireToast();
      }
      window.addEventListener("scroll", onToastScroll, { passive: true });
    })();

    /* ============================================================
       Lightweight parallax on [data-parallax] elements (the §6 app-card
       duo, the §6 floating review card, the §7 Metabolic Momentum card).
       1:1 with the source's effect: mid-point of each element vs. viewport
       mid-point, scaled by the element's own data-parallax ratio, written
       to --px (read by mid.css's `transform:translateY(var(--px,0))`).
       rAF-throttled; force --px:0px under 820px, where the CSS itself
       already turns the transform off (defensive, matches the source).
       ============================================================ */
    if (!reduceMotion) {
      var pxEls = Array.prototype.slice.call(root.querySelectorAll("[data-parallax]"));
      if (pxEls.length) {
        var ticking = false;
        var onPxScroll = function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var narrow = window.matchMedia("(max-width:820px)").matches;
            var vh = window.innerHeight;
            pxEls.forEach(function (el) {
              if (narrow) {
                el.style.setProperty("--px", "0px");
                return;
              }
              var r = el.getBoundingClientRect();
              var mid = r.top + r.height / 2;
              var off = (mid - vh / 2) * parseFloat(el.getAttribute("data-parallax") || "0.05");
              el.style.setProperty("--px", (-off).toFixed(1) + "px");
            });
            ticking = false;
          });
        };
        window.addEventListener("scroll", onPxScroll, { passive: true });
        window.addEventListener("resize", onPxScroll);
        onPxScroll();
      }
    }

    /* ============================================================
       §7 mobile scroll-snap timeline -- active-dot sync.
       The timeline becomes a horizontal scroll-snap row on phones (CSS,
       low.css). Here we keep the 3-dot nav in sync with the scroll
       position: whichever ring is nearest the horizontal centre of the
       scroll row lights its dot. rAF-throttled. On desktop the row doesn't
       scroll, so this no-ops (setActive() still runs once to confirm dot 0).
       ============================================================ */
    root.querySelectorAll("[data-timeline]").forEach(function (track) {
      var dotsWrap = track.parentElement ? track.parentElement.querySelector("[data-tldots]") : null;
      if (!dotsWrap) return;
      var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll(".mehdi-pdp__tl-dot"));
      var tiles = Array.prototype.slice.call(track.querySelectorAll(".mehdi-pdp__tl-tile"));
      if (!dots.length || !tiles.length) return;
      var current = -1;
      var tlTicking = false;
      function setActive() {
        tlTicking = false;
        var trackRect = track.getBoundingClientRect();
        var centre = trackRect.left + trackRect.width / 2;
        var best = 0;
        var bestDist = Infinity;
        tiles.forEach(function (tile, i) {
          var r = tile.getBoundingClientRect();
          var mid = r.left + r.width / 2;
          var dist = Math.abs(mid - centre);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        var idx = Math.min(best, dots.length - 1);
        if (idx !== current) {
          current = idx;
          dots.forEach(function (d, i) {
            d.classList.toggle("is-on", i === idx);
          });
        }
      }
      function onTlScroll() {
        if (tlTicking) return;
        tlTicking = true;
        requestAnimationFrame(setActive);
      }
      track.addEventListener("scroll", onTlScroll, { passive: true });
      window.addEventListener("resize", onTlScroll, { passive: true });
      setActive();
    });

    /* ============================================================
       Shared #metric-modal <dialog> -- §9 spec-grid buttons + the HSA/FSA
       "i" button (touch devices only; on hover-capable devices the CSS
       popover in mid.css handles it, matching the source's canHover split).
       ============================================================ */
    (function () {
      var modal = root.querySelector("#metric-modal");
      if (!modal) return;
      var mmTitle = modal.querySelector("#mm-title");
      var mmBody = modal.querySelector("#mm-body");
      var lastFocus = null;

      function openModal(title, body, trigger) {
        lastFocus = trigger || null;
        if (mmTitle) mmTitle.textContent = title;
        if (mmBody) mmBody.textContent = body;
        if (typeof modal.showModal === "function") {
          modal.showModal();
        } else {
          modal.setAttribute("open", "");
        }
      }
      function closeModal() {
        if (typeof modal.close === "function" && modal.open) {
          modal.close();
        } else {
          modal.removeAttribute("open");
        }
      }

      root.querySelectorAll(".mehdi-pdp__speccell").forEach(function (btn) {
        btn.addEventListener("click", function () {
          openModal((btn.querySelector("[data-mm-t]") ? btn.querySelector("[data-mm-t]").textContent : btn.getAttribute("data-metric-title")) || "", (btn.querySelector("[data-mm-b]") ? btn.querySelector("[data-mm-b]").textContent : btn.getAttribute("data-metric-body")) || "", btn);
        });
      });

      var canHover = window.matchMedia && window.matchMedia("(hover:hover)").matches;
      root.querySelectorAll("[data-hsa-modal]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (!canHover) {
            openModal((btn.querySelector("[data-mm-t]") ? btn.querySelector("[data-mm-t]").textContent : btn.getAttribute("data-modal-title")) || "", (btn.querySelector("[data-mm-b]") ? btn.querySelector("[data-mm-b]").textContent : btn.getAttribute("data-modal-body")) || "", btn);
          }
        });
      });

      var closeBtn = modal.querySelector("[data-modal-close]");
      if (closeBtn) closeBtn.addEventListener("click", closeModal);

      /* A click that lands on the dialog's own ::backdrop bubbles with
         event.target === the dialog element itself (the backdrop isn't in
         the DOM tree), which is the standard way to detect a "click
         outside the card" on a native <dialog> -- equivalent to the
         source's .modal-scrim click-to-close, one fewer node needed. */
      modal.addEventListener("click", function (e) {
        if (e.target === modal) closeModal();
      });

      /* Native <dialog> already closes on Escape (fires "cancel" then
         "close") -- no keydown listener needed, unlike the source's
         hand-rolled document.addEventListener("keydown", ...). Restore
         focus to whatever opened it, same as the source's lastFocus.focus(). */
      modal.addEventListener("close", function () {
        if (lastFocus) lastFocus.focus();
      });
    })();
  });
})();
/*
  MEHDI PDP — LOWER ZONE shared behavior.
  Ported from the mount effect in PodBelowHero.tsx / HumeBelowHero.tsx,
  reduced to vanilla bare statements, IIFE-scoped, no globals.

  Kept / restored (visual identity + interaction depends on it):
    - reveal-on-scroll (.mehdi-pdp__reveal / .mehdi-pdp__stagger -> is-in)
    - count-up on [data-count]
    - review-strip rotation (.mehdi-pdp__revstrip)
    - mech segmental card Muscle/Fat toggle (.mehdi-pdp__seg-toggle)
    - scroll parallax on [data-parallax] (source: pod-photo data-parallax +
      a passive rAF scroll listener writing a translateY offset; ported here
      as a --ml-px custom property consumed by low.css's translate3d)
    - chart / ring hover tooltips on [data-hoverpts] (source: a shared
      floating #chart-tt node positioned from mousemove; mouse on desktop,
      tap on touch — the tap wiring is an addition, source only had
      mousemove, see low.notes.md)
    - spec-grid metric modal, restored as a native <dialog> (source opens
      a real modal here, not an accordion; showModal() gives focus-trap +
      Escape for free, backdrop-click-to-close is wired below)

  Every motion effect respects prefers-reduced-motion: reveals show
  immediately, count-ups render their final value with no animation, the
  review strip does not auto-rotate (manual prev/next still works), and
  parallax settles at --ml-px:0 (no offset, final resting position).
*/
(function () {
  "use strict";

  document.querySelectorAll(".mehdi-pdp").forEach(function (root) {
    if (root.__mehdiPdpLowInit) return;
    root.__mehdiPdpLowInit = true;

    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* ---------------- reveal-on-scroll ---------------- */
    var revealTargets = root.querySelectorAll(".mehdi-pdp__reveal, .mehdi-pdp__stagger");
    if (reduceMotion || !("IntersectionObserver" in window)) {
      revealTargets.forEach(function (el) { el.classList.add("is-in"); });
    } else {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-in");
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "0px 0px -8% 0px", threshold: 0.15 }
      );
      revealTargets.forEach(function (el) { io.observe(el); });
      /* Source parity: HumeReasonVisuals' useInViewOnce carries a 1.6s safety
         net that runs the reveal even if the observer never fires. Same here —
         no element may stay stuck at opacity 0. */
      setTimeout(function () {
        revealTargets.forEach(function (el) { el.classList.add("is-in"); });
      }, 1600);
    }

    /* ---------------- count-up on [data-count] ---------------- */
    function countUp(el) {
      var target = parseFloat(el.getAttribute("data-count"));
      if (isNaN(target)) return;
      var decimals = parseInt(el.getAttribute("data-decimals") || "0", 10);
      var suffix = el.getAttribute("data-suffix") || "";
      if (reduceMotion) {
        el.textContent = target.toFixed(decimals) + suffix;
        return;
      }
      var start = null;
      var duration = 1100;
      function tick(now) {
        if (start === null) start = now;
        var p = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    var countTargets = root.querySelectorAll("[data-count]");
    if (reduceMotion || !("IntersectionObserver" in window)) {
      countTargets.forEach(countUp);
    } else {
      var countIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              countUp(entry.target);
              countIo.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.4 }
      );
      countTargets.forEach(function (el) { countIo.observe(el); });
    }

    /* ---------------- review-strip rotation ---------------- */
    root.querySelectorAll(".mehdi-pdp__revstrip").forEach(function (strip) {
      var quotes = Array.prototype.slice.call(strip.querySelectorAll(".mehdi-pdp__rq"));
      if (quotes.length < 2) return;
      var idx = quotes.findIndex(function (q) { return q.classList.contains("is-on"); });
      if (idx < 0) idx = 0;
      var timer = null;

      function show(next) {
        quotes[idx].classList.remove("is-on");
        idx = (next + quotes.length) % quotes.length;
        quotes[idx].classList.add("is-on");
      }
      function restart() {
        if (reduceMotion) return;
        if (timer) clearInterval(timer);
        timer = setInterval(function () { show(idx + 1); }, 5000);
      }

      strip.querySelectorAll("[data-rv-up]").forEach(function (btn) {
        btn.addEventListener("click", function () { show(idx - 1); restart(); });
      });
      strip.querySelectorAll("[data-rv-down]").forEach(function (btn) {
        btn.addEventListener("click", function () { show(idx + 1); restart(); });
      });
      restart();
    });

    /* ---------------- mech segmental card: Muscle (kg) / Fat (%) toggle ---------------- */
    root.querySelectorAll("[data-seg-toggle]").forEach(function (toggle) {
      var card = toggle.closest("[data-seg-card]");
      if (!card) return;
      var title = card.querySelector("[data-seg-title]");
      var buttons = Array.prototype.slice.call(toggle.querySelectorAll(".mehdi-pdp__ptab"));
      var values = Array.prototype.slice.call(card.querySelectorAll(".sv"));

      function setMode(mode) {
        buttons.forEach(function (btn) {
          var on = btn.getAttribute("data-mode") === mode;
          btn.classList.toggle("is-on", on);
          btn.setAttribute("aria-pressed", on ? "true" : "false");
        });
        if (title) {
          var segLabels = title.querySelectorAll("[data-seg-l]");
          if (segLabels.length) {
            Array.prototype.forEach.call(segLabels, function (l) { l.hidden = l.getAttribute("data-seg-l") !== mode; });
          } else {
            title.textContent = mode === "fat" ? "Fat Rate By Body Parts" : "Muscle Mass By Body Parts";
          }
        }
        values.forEach(function (v) {
          var raw = v.getAttribute(mode === "fat" ? "data-fat" : "data-muscle");
          if (!raw) return;
          var parts = raw.split("|");
          v.innerHTML = parts[0] + '<span class="u">' + (parts[1] || "") + "</span>";
        });
      }

      buttons.forEach(function (btn) {
        btn.addEventListener("click", function () { setMode(btn.getAttribute("data-mode")); });
      });
    });

    /* ---------------- scroll parallax on [data-parallax] photo accents ---------------- */
    var pxEls = Array.prototype.slice.call(root.querySelectorAll("[data-parallax]"));
    if (pxEls.length) {
      if (reduceMotion) {
        pxEls.forEach(function (el) { el.style.setProperty("--ml-px", "0px"); });
      } else {
        var pxTicking = false;
        var onPxScroll = function () {
          if (pxTicking) return;
          pxTicking = true;
          requestAnimationFrame(function () {
            var narrow = window.matchMedia("(max-width:820px)").matches;
            var vh = window.innerHeight;
            pxEls.forEach(function (el) {
              if (narrow) { el.style.setProperty("--ml-px", "0px"); return; }
              var r = el.getBoundingClientRect();
              var mid = r.top + r.height / 2;
              var off = (mid - vh / 2) * parseFloat(el.getAttribute("data-parallax") || "0.05");
              el.style.setProperty("--ml-px", (-off).toFixed(1) + "px");
            });
            pxTicking = false;
          });
        };
        window.addEventListener("scroll", onPxScroll, { passive: true });
        window.addEventListener("resize", onPxScroll, { passive: true });
        onPxScroll();
      }
    }

    /* ---------------- chart / ring hover-tooltips ([data-hoverpts]) ---------------- */
    var tt = root.querySelector(".mehdi-pdp__chart-tt");
    function showTT(x, y, text) {
      if (!tt) return;
      tt.textContent = text;
      tt.style.left = x + "px";
      tt.style.top = y + "px";
      tt.classList.add("is-on");
    }
    function hideTT() {
      if (tt) tt.classList.remove("is-on");
    }
    /* The tooltip is position:fixed, so once the page scrolls it would float
       over whatever comes next (seen on mobile after a tap on a ring card):
       any scroll hides it; a hover or tap re-shows it. */
    if (tt) window.addEventListener("scroll", hideTT, { passive: true });

    /* line charts: nearest vertex by x, mouse on desktop, tap on touch */
    root.querySelectorAll("svg[data-hoverpts]").forEach(function (svg) {
      if (svg.__mehdiTTBound) return;
      svg.__mehdiTTBound = true;
      var line = svg.querySelector(".mehdi-pdp__chartline");
      var node = svg.querySelector(".mehdi-pdp__hover-node");
      if (!line) return;
      var pts;
      try { pts = JSON.parse(svg.getAttribute("data-hoverpts") || "[]"); } catch (e) { return; }
      var d = line.getAttribute("d") || "";
      var coords = (d.match(/[ML]\s*(-?[\d.]+)[ ,](-?[\d.]+)/g) || []).map(function (seg) {
        var m = seg.match(/(-?[\d.]+)[ ,](-?[\d.]+)/);
        return { x: parseFloat(m[1]), y: parseFloat(m[2]) };
      });
      if (!coords.length) return;
      function nearest(clientX, clientY) {
        var r = svg.getBoundingClientRect();
        var vb = svg.viewBox.baseVal;
        var relX = ((clientX - r.left) / r.width) * vb.width;
        var best = 0, bd = 1e9;
        coords.forEach(function (c, i) {
          var dd = Math.abs(c.x - relX);
          if (dd < bd) { bd = dd; best = i; }
        });
        var idx = Math.min(best, pts.length - 1);
        var c = coords[best];
        return { c: c, idx: idx, sx: r.left + (c.x / vb.width) * r.width, sy: r.top + (c.y / vb.height) * r.height };
      }
      function reveal(res) {
        if (node) { node.setAttribute("cx", res.c.x); node.setAttribute("cy", res.c.y); node.classList.add("is-on"); }
        showTT(res.sx, res.sy, pts[res.idx].label);
      }
      svg.addEventListener("mousemove", function (ev) { reveal(nearest(ev.clientX, ev.clientY)); });
      svg.addEventListener("mouseleave", function () { hideTT(); if (node) node.classList.remove("is-on"); });
      svg.addEventListener("touchstart", function (ev) {
        var t = ev.touches && ev.touches[0];
        if (t) reveal(nearest(t.clientX, t.clientY));
      }, { passive: true });
    });

    /* rings: single meaningful readout tooltip, mouse on desktop; on touch a
       tap toggles it (second tap on the same ring closes it) */
    root.querySelectorAll(".mehdi-pdp__ring-wrap[data-hoverpts]").forEach(function (rw) {
      /* The tail fragment opens a nested .mehdi-pdp root, so this loop runs
         once per root and would bind every ring twice (the second binding
         toggled the tooltip straight back off on touch). Bind once. */
      if (rw.__mehdiTTBound) return;
      rw.__mehdiTTBound = true;
      var pts;
      try { pts = JSON.parse(rw.getAttribute("data-hoverpts") || "[]"); } catch (e) { return; }
      var touchedAt = 0;
      function reveal(clientX, clientY) { if (pts[0]) showTT(clientX, clientY - 8, pts[0].label); }
      /* a tap also fires the compatibility mousemove ~300ms later: ignore it */
      rw.addEventListener("mousemove", function (ev) { if (Date.now() - touchedAt < 1000) return; reveal(ev.clientX, ev.clientY); });
      rw.addEventListener("mouseleave", hideTT);
      rw.addEventListener("touchstart", function (ev) {
        var t = ev.touches && ev.touches[0];
        if (!t) return;
        touchedAt = Date.now();
        if (tt && tt.classList.contains("is-on") && tt.textContent === pts[0].label) { hideTT(); return; }
        reveal(t.clientX, t.clientY);
      }, { passive: true });
    });

    /* tapping anywhere outside a hoverpts target hides an open tooltip */
    if (tt) {
      document.addEventListener("touchstart", function (ev) {
        if (!tt.classList.contains("is-on")) return;
        var target = ev.target;
        if (target && target.closest && (target.closest("svg[data-hoverpts]") || target.closest(".mehdi-pdp__ring-wrap[data-hoverpts]"))) return;
        hideTT();
      }, { passive: true });
    }

    /* ---------------- spec-grid metric modal (native <dialog>) ---------------- */
    var modal = root.querySelector(".mehdi-pdp__modal");
    if (modal) {
      var mmTitle = modal.querySelector(".mehdi-pdp__modal-title");
      var mmBody = modal.querySelector(".mehdi-pdp__modal-body");
      var lastFocus = null;
      var hasNativeDialog = typeof modal.showModal === "function";

      function openModal(title, body, trigger) {
        lastFocus = trigger || null;
        if (mmTitle) mmTitle.textContent = title;
        if (mmBody) mmBody.textContent = body;
        if (hasNativeDialog) modal.showModal();
        else modal.setAttribute("open", "");
      }
      function closeModal() {
        if (hasNativeDialog) modal.close();
        else modal.removeAttribute("open");
      }

      root.querySelectorAll(".mehdi-pdp__speccell").forEach(function (btn) {
        btn.addEventListener("click", function () {
          openModal((btn.querySelector("[data-mm-t]") ? btn.querySelector("[data-mm-t]").textContent : btn.getAttribute("data-metric-title")) || "", (btn.querySelector("[data-mm-b]") ? btn.querySelector("[data-mm-b]").textContent : btn.getAttribute("data-metric-body")) || "", btn);
        });
      });
      modal.querySelectorAll("[data-modal-close]").forEach(function (el) {
        el.addEventListener("click", closeModal);
      });
      /* <dialog> has no built-in light-dismiss: a click that lands outside
         the modal's own box (i.e. on the ::backdrop) closes it. */
      modal.addEventListener("click", function (ev) {
        var r = modal.getBoundingClientRect();
        var inside = ev.clientX >= r.left && ev.clientX <= r.right && ev.clientY >= r.top && ev.clientY <= r.bottom;
        if (!inside) closeModal();
      });
      /* Escape-to-close is native <dialog> behavior; "close" fires either way
         (backdrop click, Escape, or the close button) so focus return is centralized here. */
      modal.addEventListener("close", function () {
        if (lastFocus) lastFocus.focus();
      });
    }
  });
})();

/* BAND BUY-BOX PORT (audit C6, 2026-08-23) — info-tab switcher + stock-bar
   counters. The stock countdown itself reuses the existing shared
   [data-mehdi-countdown] local-midnight binding above; nothing new there. */
(function () {
  "use strict";

  /* Tabs: BENEFITS / WHAT IT MEASURES / HOW TO USE */
  document.querySelectorAll("[data-mehdi-bbtabs]").forEach(function (root) {
    var tabs = root.querySelectorAll(".mehdi-pdp__bbtabs-tab");
    var panels = root.querySelectorAll(".mehdi-pdp__bbtabs-panel");
    tabs.forEach(function (tab, i) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t, j) {
          var on = j === i;
          t.classList.toggle("is-active", on);
          t.setAttribute("aria-selected", on ? "true" : "false");
        });
        panels.forEach(function (p, j) {
          var on = j === i;
          p.classList.toggle("is-active", on);
          if (on) { p.removeAttribute("hidden"); } else { p.setAttribute("hidden", ""); }
        });
      });
    });
  });

  /* "N sold today" — the ref's NYC-weighted daily curve (350 → 2,200), same
     hourly weights as StockInventoryBar.tsx, refreshed every 2 minutes. */
  var soldEl = document.querySelector("[data-mehdi-sold]");
  if (soldEl) {
    var weights = [0.5,0.5,0.5,0.5,0.5,0.5,1,1.5,2,4,4,3,2,2,2,2,2,4,4.5,4.5,4,2,1.5,1];
    var total = weights.reduce(function (a, b) { return a + b; }, 0);
    var soldTick = function () {
      var nyc;
      try {
        nyc = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
      } catch (e) { nyc = new Date(); }
      var cum = 0;
      for (var h = 0; h < nyc.getHours(); h++) cum += weights[h];
      cum += weights[nyc.getHours()] * (nyc.getMinutes() / 60);
      var n = Math.floor(350 + 1850 * (cum / total));
      soldEl.textContent = n.toLocaleString("en-US");
    };
    soldTick();
    setInterval(soldTick, 120000);
  }

  /* "N viewing" — random walk 35–65 like the ref, desktop-only element. */
  var viewEl = document.querySelector("[data-mehdi-viewing]");
  if (viewEl) {
    var viewers = 46;
    setInterval(function () {
      viewers = Math.max(35, Math.min(65, viewers + (Math.random() > 0.5 ? 1 : -1)));
      viewEl.textContent = String(viewers);
    }, 3000 + Math.random() * 2000);
  }
})();


/* Hero rating stars scroll to the reviews section (Mehdi 2026-08-23) */
(function () {
  "use strict";
  document.querySelectorAll(".mehdi-pdp__hero-rating-btn[data-rating-target]").forEach(function (btn) {
    function go() {
      var t = document.querySelector(btn.getAttribute("data-rating-target"));
      if (!t) return;
      window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 72, behavior: "smooth" });
    }
    btn.addEventListener("click", go);
    btn.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); go(); } });
  });
})();
